module.exports = __webpack_public_path__ + "static/img/2021-09-05.a1d5978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/press/2021-09-05.png
// module id = GPkP
// module chunks = 1